import { ReactNode } from 'react';
import { useOptiAssets } from '@/hooks/useOptiAssets';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

interface OptiAssetsGateProps {
  children: ReactNode;
}

/**
 * Gate component for OptiAssets feature
 * Shows locked screen if OPTIASSETS addon is not enabled
 */
export function OptiAssetsGate({ children }: OptiAssetsGateProps) {
  const { isEnabled, canView } = useOptiAssets();
  const navigate = useNavigate();
  
  // Check both addon enabled AND permission to view
  if (!isEnabled || !canView) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] p-8 text-center">
        <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-6">
          <Lock className="h-8 w-8 text-muted-foreground" />
        </div>
        <h2 className="text-2xl font-semibold mb-2">
          {!isEnabled ? 'OptiAssets Not Enabled' : 'Access Restricted'}
        </h2>
        <p className="text-muted-foreground max-w-md mb-6">
          {!isEnabled 
            ? 'Equipment tracking and analytics is available as an add-on feature. Contact your account manager to enable OptiAssets for your shop.'
            : 'OptiAssets is available to managers only. Please contact your shop manager for access.'}
        </p>
        <Button variant="outline" onClick={() => navigate(-1)}>
          Go Back
        </Button>
      </div>
    );
  }
  
  return <>{children}</>;
}
